import React from "react";
import { Table } from "reactstrap";
import { addClassName } from "../../../Utils/Add-ClassName.js";
import { calcPercentage } from "../../../Utils/calculate-progress.js";
import LayoutCard from "../../Layout/Layout";
import DropDown from "./DropDown/DropDown";
import MyReportsIcon from "../../../../images/new-images/myreports.png";
import "./DownloadReports.css";
import { Row, Col } from "reactstrap";
import completed from "../../../../images/new-images/completed.png";
import Devplan from "./DropDown/Devplan-dropdown";
import Renderselfloireport from "./Selfloireport";
import Pdfloader from "../../Data-loader/pdf-loader";
import Button from "../../../Utils/Button/index.jsx";

const DownloadReports = (props) => {



  const newFilteredData = [];
  props.assessmentDetails &&
    props.assessmentDetails.respondents.filter((onlyFilterData) => {
      if (onlyFilterData.assessment_status__status_name == "Completed") {
        return newFilteredData.push(onlyFilterData);
      }
    });

  const isVVI = props.assessmentDetails && props.assessmentDetails.instrument__instrument_name === "VVI";

 


  return (
    <LayoutCard headerIcon={MyReportsIcon} headerText="My Reports">
      {props.dataloader && (
        <Pdfloader loaderText="Downloading your file please wait..." />
      )}
      <div className="download-reports">
        {props.checkMultiRater == true ? (
          <div className="downloadreport-assessmentType">
            <div>
              <Row>
                <Col md="12">
                  <div className="flex-align-center">
                    {props.assessmentDetails && props.assessmentDetails.instrument__instrument_image && (
                      <img
                        className="downloadreport-assessmentIcon"
                        src={
                          localStorage.getItem("baseLink") +
                          `/media/` +
                          props.assessmentDetails.instrument__instrument_image
                        }
                        alt="Assessment Icon"
                      />
                    )}
                    <div>
                      <p className="downloadreport-assessmentName">
                        {props.assessmentDetails &&
                          props.assessmentDetails.instrument__dashboard_header_text}
                      </p>
                      <p className="downloadreport-userName">
                        {props.assessmentDetails &&
                          props.assessmentDetails.participant__full_name}
                        's
                        <span style={{ marginLeft: "5px" }}>
                          {props.assessmentDetails &&
                            props.assessmentDetails.instrument__instrument_name}
                        </span>
                      </p>
                    </div>
                  </div>
                </Col>
              </Row>
            </div>
            <div className="text-and-dropdown">
              <Row>
                <Col md="3">
                  <Devplan
                    devPlan={props.devPlan}
                    devPlanList={props.devPlanList}
                    handleDevPlanDownload={props.handleDevPlanDownload}
                    handleSelfDevPlanDownload={props.handleSelfDevPlanDownload}
                    assessmentDetails={props.assessmentDetails}
                  />
                </Col>
                <Col md="6">
                  <p className="report-text">
                    {props.devPlanList.length == 0 &&
                      props.downloadReportDropdown.length == 0
                      ? "No Reports are avaliable for download"
                      : "Congratulations! Your reports are ready for download."}
                  </p>
                </Col>
                <Col md="3">
                  <DropDown
                    downloadReportDropdown={props.downloadReportDropdown}
                    handlePdfDownload={props.handlePdfDownload}
                    enable_report={props.assessmentDetails.enable_report}
                  />
                </Col>
              </Row>
            </div>
            <div className="custom-height">
              <Table>
                <thead>
                  <tr>
                    <th className="tableHeaders">Email ID</th>
                    <th className="tableHeaders">Relationship</th>
                    <th className="tableHeaders">Status</th>
                  </tr>
                </thead>
                <tbody>
                  <React.Fragment>
                    {newFilteredData.map((getRespondants, index) => (
                      <tr key={index}>
                        <td>{getRespondants.respondent__email}</td>
                        <td>{getRespondants.assessor_group__assessor_name}</td>
                        <td>
                          {getRespondants.assessment_status__status_name ===
                            "In progress" ? (
                            <div
                              style={{ display: "flex" }}
                              className={
                                "assessment-status-text " +
                                addClassName(
                                  getRespondants.assessment_status__status_name
                                )
                              }
                            >
                              {getRespondants.assessment_status__status_name}
                              {calcPercentage(
                                getRespondants.assessment_number_count,
                                getRespondants.assessment_completed_count
                              )}
                            </div>
                          ) : getRespondants.assessment_status__status_name ===
                            "Completed" ? (
                            <div
                              className={
                                "assessment-status-text " +
                                addClassName(
                                  getRespondants.assessment_status__status_name
                                )
                              }
                            >
                              {getRespondants.assessment_status__status_name}
                              <img src={completed} alt="Completed Image" />
                            </div>
                          ) : (
                            <div
                              className={
                                "assessment-status-text " +
                                addClassName(
                                  getRespondants.assessment_status__status_name
                                )
                              }
                            >
                              {getRespondants.assessment_status__status_name}
                            </div>
                          )}
                        </td>
                      </tr>
                    ))}
                  </React.Fragment>
                </tbody>
              </Table>
            </div>
          </div>
        ) : (

          <div>
            <div>
              <Row>
                <Col md="12">
                  <div className="flex-align-center">
                    {props.assessmentDetails &&
                      props.assessmentDetails.instrument__instrument_image && (
                        <img
                          className="downloadreport-assessmentIcon"
                          src={
                            localStorage.getItem("baseLink") +
                            `/media/` +
                            props.assessmentDetails.instrument__instrument_image
                          }
                          alt="Assessment Icon"
                        />
                      )}
                    <div>
                      <p className="downloadreport-assessmentName">
                        {props.assessmentDetails &&
                          props.assessmentDetails.instrument__dashboard_header_text}
                      </p>
                      <p className="downloadreport-userName">
                        {props.assessmentDetails &&
                          props.assessmentDetails.participant__full_name}
                        {props.assessmentDetails &&
                          props.assessmentDetails.participant__full_name &&
                          "'s"}
                        <span style={{ marginLeft: "5px" }}>
                          {props.assessmentDetails &&
                            props.assessmentDetails.instrument__instrument_name}
                        </span>
                      </p>
                    </div>
                  </div>
                </Col>
              </Row>
            </div>
            <div className="text-and-dropdown">
              <Row>
                {!isVVI && (
                  <Col md="3">
                    {props.devPlanList.length === 0 ? (
                      <Button
                        style={{
                          backgroundColor: "#a0a5ab",
                          color: "white",
                          padding: 0,
                        }}
                        type="disabled report"
                      >
                        DOWNLOAD DEV PLAN
                      </Button>
                    ) : (
                      <Devplan
                        devPlan={props.devPlan}
                        devPlanList={props.devPlanList}
                        handleDevPlanDownload={props.handleDevPlanDownload}
                        handleSelfDevPlanDownload={props.handleSelfDevPlanDownload}
                        assessmentDetails={props.assessmentDetails}
                      />
                    )}
                  </Col>
                )}
                <Col md={isVVI ? "12" : "6"}>
                  <p className="report-text">
                    Congratulations! Your reports are ready for download.
                  </p>
                </Col>
                {isVVI && (
                  <Col md="12">
                    <Row className="justify-content-center" style={{ marginTop: "20px" }}>
                      {props.downloadReportDropdown.length === 0 ? (
                        props.assessmentDetails && props.assessmentDetails.enable_report ? (
                          <button
                            className="self-submit-button"
                            onClick={() =>
                              props.handleSelfReportDownload(
                                props.assessmentDetails.id,
                                props.assessmentDetails.participant__id,
                                props.assessmentDetails.instrument__instrument_name
                              )
                            }
                          >
                            Download
                          </button>
                        ) : (
                          <Button
                            style={{ backgroundColor: "#a0a5ab", color: "white" }}
                            type="disabled report"
                          >
                            DOWNLOAD
                          </Button>
                        )
                      ) : (
                        <DropDown
                          downloadReportDropdown={props.downloadReportDropdown}
                          handlePdfDownload={props.handlePdfDownload}
                        />
                      )}
                    </Row>
                  </Col>
                )}
                {!isVVI && (
                  <Col md="3">
                    {props.downloadReportDropdown.length === 0 ? (
                      props.assessmentDetails && props.assessmentDetails.enable_report ? (
                        <button
                          className="self-submit-button"
                          onClick={() =>
                            props.handleSelfReportDownload(
                              props.assessmentDetails.id,
                              props.assessmentDetails.participant__id,
                              props.assessmentDetails.instrument__instrument_name
                            )
                          }
                        >
                          Download
                        </button>
                      ) : (
                        <Button
                          style={{ backgroundColor: "#a0a5ab", color: "white" }}
                          type="disabled report"
                        >
                          DOWNLOAD
                        </Button>
                      )
                    ) : (
                      <DropDown
                        downloadReportDropdown={props.downloadReportDropdown}
                        handlePdfDownload={props.handlePdfDownload}
                      />
                    )}
                  </Col>
                )}
              </Row>
            </div>
          </div>
        )}
      </div>
    </LayoutCard>
  );
};

export default DownloadReports;




// WEBPACK FOOTER //
// ./src/new/Components/Reports/Download-Reports/DownloadReports.jsx